<template>
  <section v-show="active" class="app-modal__section">
    <div class="app-modal__section-head">
      <h4>{{ text.modal.form.contact.title }}</h4>
      <p>{{ text.modal.form.contact.subtitle }}</p>
    </div>

    <div class="app-modal__grid two-columns">
      <label class="app-modal-field full-width">
        <span>{{ text.modal.form.contact.fields.email }}</span>
        <input
          v-model="form.email"
          type="email"
          class="form-control"
          :placeholder="text.modal.form.contact.placeholders.email"
          @blur="v$.form.email.$touch()"
          :class="{ 'is-invalid': v$.form.email.$error }"
        />
        <div class="invalid-feedback d-block" v-if="v$.form.email.$error">
          <span v-if="v$.form.email.$errors.length">{{ v$.form.email.$errors[0].$message }}</span>
        </div>
      </label>

      <label class="app-modal-field">
        <span>{{ text.modal.form.contact.fields.phone }}</span>
        <input v-model="form.phone" type="text" class="form-control" :placeholder="text.modal.form.contact.placeholders.phone" />
      </label>

      <label class="app-modal-field">
        <span>{{ text.modal.form.contact.fields.portfolio }}</span>
        <input v-model="form.portfolio" type="text" class="form-control" :placeholder="text.modal.form.contact.placeholders.portfolio" />
      </label>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('suppliers');

export default {
  name: 'SupplierSectionContact',
  props: {
    active: { type: Boolean, default: false },
    form: { type: Object, required: true },
    v$: { type: Object, required: true },
  },
  data() {
    return {
      text,
    };
  },
};
</script>
